export default "__VITE_ASSET__CZYh3NlS__"